<template>
  <div class="row col-12">
    <div class="col">
      <div class="text-brand-1 text-weight-bold">{{ label }}</div>
      <q-input
        dense
        outlined
        type="number"
        :label="placeholder"
        hide-bottom-space
        v-model="valor"
        :rules="[(val) => !!val || validateMessage]"
      />
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";

export default {
  name: "ComponentTypeNumber",
  emits: ["enviarValor"],
  props: {
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
    },
    value: {
      type: Number,
    },
    validateMessage: {
      type: String,
      default: "Campo obrigatório",
    },
    required: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const valor = ref(props.value);

    watch(
      () => props.value,
      () => {
        if (valor.value === props.value) {
          return;
        }
        valor.value = props.value;
      }
    );

    watch(
      () => valor.value,
      () => {
        emit("enviarValor", { value: valor.value, name: props.name });
      }
    );

    return { valor };
  },
};
</script>
